/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SuperuserCompanyContextService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get company context for a company (superuser only)
   * @param companyUuid UUID of the company
   * @returns any Company context retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesSuperuserCompanyContext(
    companyUuid: string,
  ): CancelablePromise<{
    data?: {
      companyContext?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/superuser/company-context/{companyUuid}',
      path: {
        'companyUuid': companyUuid,
      },
      errors: {
        403: `Forbidden - superuser role required`,
        404: `Company not found`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Update company context for a company (superuser only)
   * @param companyUuid UUID of the company
   * @param requestBody
   * @returns any Company context updated successfully
   * @throws ApiError
   */
  public patchApiServiceorganizationsProcessesSuperuserCompanyContext(
    companyUuid: string,
    requestBody: {
      /**
       * Free-form context notes about the company
       */
      companyContext: string;
    },
  ): CancelablePromise<{
    data?: {
      companyContext?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/processes/superuser/company-context/{companyUuid}',
      path: {
        'companyUuid': companyUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request - validation error`,
        403: `Forbidden - superuser role required`,
        404: `Company not found`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Get company context for prompt injection (MCP v2)
   * @param requestBody
   * @returns any Company context retrieved successfully
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesMcpCompanyContext(
    requestBody: {
      /**
       * UUID of the authenticated user
       */
      userUuid?: string;
      /**
       * UUID of the company
       */
      companyUuid: string;
    },
  ): CancelablePromise<{
    data?: {
      context?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/mcp/company-context',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Company not found`,
        500: `Internal server error`,
      },
    });
  }

}
